import { axios } from 'system/axios'

import { OwnProfile } from './types/OwnProfile'

export const patchOwnProfile = (patch: Partial<OwnProfile>) => axios.patch<OwnProfile>('/user/me', patch)
